import { Card, Col, Row } from 'react-bootstrap';

import { DefaultSpinnerCenter } from '@components/Loader/Loader';
import { ClosedTicketsTable } from '@components/Tickets/TicketsTable';
import { Page500 } from '@containers/ErrorPages';
import { ticketApi } from '@reducers/tickets/tickets';

export const TicketsHistory = () => {
  const { data, isLoading, isError, error } = ticketApi.useGetHistoryQuery();
  if (isLoading) {
    return <DefaultSpinnerCenter />;
  }
  if (isError) {
    return <Page500 />;
  }
  return (
    <Row>
      <Col md={12}>
        <Card>
          <Card.Header className="bg-didxl text-white">
            Tickets history
          </Card.Header>
          <Card.Body>
            {isError ? (
              <span className="textRed">{error.data}</span>
            ) : (
              <ClosedTicketsTable data={data} />
            )}
          </Card.Body>
        </Card>
      </Col>
    </Row>
  );
};
